import React, { useEffect, useRef, useState } from "react";
import { Container } from "reactstrap";

//Import Components
// Redux
import { Icon } from "@iconify/react/dist/iconify.js";
import { Checkbox, Grid, LinearProgress, Stack } from "@mui/material";
import { connect, useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";
import AppTab from "../../components/Common/AppTab";
import Label from "../../components/Common/Label";
import LoadingDialog from "../../components/Common/LoadingDialog";
import Notification from "../../components/Common/Notification";
import SearchBar from "../../components/Common/Searchbar";
import Table from "../../components/Common/Table";
import TablePageControl from "../../components/Common/TablePageControl";
import CustomButton from "../../components/Form/CustomButton";
import CustomSelect2 from "../../components/Form/CustomSelect2";
import RenderPopOverButton from "../../components/Form/RenderPopOverButton";
import Helpers from "../../helpers/helpers";
import { bulkUpdateAdvert, deleteAdvert, getDashboardInfo, getDashboardOptions, resetAdvertActionState, resetDashboardState, updateAdvert } from "../../store/actions";
import PopOverFilter from "../../components/Common/PopoverFilter";
import moment from "moment";
import AppDialog from "../../components/Common/AppDialog";
import MoveDraft from "../Advert/modal/MoveDraft";
import RenewAdvert from "../Advert/modal/RenewAdvert";
import PublishAdvert from "../Advert/modal/PublishAdvert";
import MarkSold from "../Advert/modal/MarkSold";
import Toggle from "../../components/Common/Toggle";
import CustomTextField from "../../components/Form/CustomTextField";
import MarkReserved from "../Advert/modal/MarkReserved";
import RevertStatus from "../Advert/modal/RevertStatus";
import MoveToHidden from "../Advert/modal/MoveToHidden";

const Dashboard = (props) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [loading, setIsLoading] = useState(false);
    const [tabValue, setTabValue] = useState('all');
    const [currentDealer, setCurrentCompany] = useState(null);
    const [page, setPage] = useState(1);
    const [length, setLength] = useState("10");
    const [search, setSearch] = useState("");
    const [sort, setSorted] = useState("desc");
    const [sort_by, setSortBy] = useState("id");
    const [checkedAll, setCheckedAll] = useState(false);
    const [width, setWidth] = useState(window.innerWidth);
    const [editable, setEditable] = useState(true);
    const [startSelecting, setStartSelecting] = useState(false);
    const [selectedIds, setSelectedIds] = useState([]);
    const [selectedRow, setSelectedRow] = useState([]);
    const [deletable, setDeletable] = useState(true);
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [soldOpen, setSoldOpen] = useState(false);
    const [publishOpen, setPublishOpen] = useState(false);
    const [renewOpen, setRenewOpen] = useState(false);
    const [moveDraftOpen, setMoveDraftOpen] = useState(false);
    const [deleteOpen, setDeleteOpen] = useState(false);
    const [revertStatusOpen, setRevertStatusOpen] = useState(false);
    const [moveToHiddenOpen, setMoveToHiddenOpen] = useState(false);
    const [revertStatus, setRevertStatus] = useState(false);
    const [reservedOpen, setReservedOpen] = useState(false);
    const [filterObject, setFilterObject] = useState({ status: "all", advert_type: ['all'], make: [], model: [], bike_type: [], licenseCategory: [] });
    const [showAll, setShowAll] = useState(false);
    const itemsToShow = showAll ? selectedRow : selectedRow.slice(0, 2);
    const [notification, setNotification] = useState({
        open: false,
        msg: "",
        type: "success",
    });
    const searchRef = useRef(search);

    useEffect(() => {
        const handleResize = () => {
            setWidth(window.innerWidth); // Update state when window resizes
        };
        window.addEventListener("resize", handleResize);
        return (() => {
            window.removeEventListener("resize", handleResize); // Cleanup on unmount
        })
    }, []);

    useEffect(() => {
        dispatch(resetDashboardState());
        dispatch(getDashboardOptions());
    }, [])

    useEffect(() => {
        initData();
    }, [page, length, sort, sort_by, tabValue, currentDealer])

    useEffect(() => {
        if (props?.dashboardInfo?.data) {
            !currentDealer && setCurrentCompany(Number(props?.dashboardInfo?.data?.dealer_id));
            setIsLoading(false);
        }
    }, [props.dashboardInfo])

    useEffect(() => {
        if (props?.editAdvert?.code === 'success' || props?.editAdvertFeatured?.code === 'success') {
            setNotification({
                open: true,
                type: 'success',
                msg: props?.editAdvertFeatured?.message || 'Advert updated successfully.'
            });
            initData();

            moveDraftOpen && setMoveDraftOpen(false);
            publishOpen && setPublishOpen(false);
            renewOpen && setRenewOpen(false);
            soldOpen && setSoldOpen(false);
            reservedOpen && setReservedOpen(false);
            revertStatusOpen && setRevertStatusOpen(false);
            moveToHiddenOpen && setMoveToHiddenOpen(false);

            selectedIds && setSelectedIds([]);
            selectedRow && setSelectedRow([]);
            dispatch(resetAdvertActionState());
        }
    }, [props?.editAdvert, props?.editAdvertFeatured])

    useEffect(() => {
        if (props?.advertDelete?.code === 'success') {
            setDeleteOpen(false);
            setNotification({ open: true, msg: props?.advertDelete?.message || 'Advert deleted successfully', type: 'success' });
            setSelectedIds([]);
            setSelectedRow([]);
            initData();
            dispatch(resetAdvertActionState());
        }
    }, [props?.advertDelete])

    useEffect(() => {
        searchRef.current = search || '';
    }, [search]);

    const deleteCheckBox = [
        {
            Header: "#",
            accessor: (cellProps) => {
                return (
                    <div className="text-center" onClick={(e) => e.stopPropagation()}>
                        <Checkbox
                            checked={checkedAll ? checkedAll : selectedIds && selectedIds?.length > 0 && selectedIds?.includes(cellProps.id)}
                            checkedIcon={Helpers.checkIcon()}
                            icon={<div style={{ width: 18, height: 18, borderRadius: 3, border: '2px solid #1D1B1B' }}></div>}
                            sx={{
                                '&.Mui-checked': {
                                    color: "#a0a0a0",
                                },
                                '& .MuiSvgIcon-root': {
                                    fontSize: 18,
                                },
                            }}
                            value={cellProps.id}
                            onChange={(event) => { handleCheckboxChange(event.target.value, cellProps) }} />
                    </div>
                )
            },
        },
    ]

    const vehicleStatusList = [
        { label: 'New', value: 'new', color: '#2C7F41' },
        { label: 'Used', value: 'used', color: '#FF8D28' },
        { label: 'Rental', value: 'rental', color: '#475A99' },
    ]


    const getHeader = () => {
        let data =
        {
            Header: "HP Application",
            minWidth: 300,
            accessor: (cellProps) => {
                return (
                    <Grid container spacing={2}>
                        <Grid item sm={4}>
                            <div className="text-bold">{cellProps?.submitted || "0"}</div>
                            <div className="subheader-2 font-size-12">Submitted</div>
                        </Grid>
                        <Grid item sm={4}>
                            <div className="text-bold">{cellProps?.approved || "0"}</div>
                            <div className="subheader-2 font-size-12">Approved</div>
                        </Grid>
                        <Grid item sm={4}>
                            <div className="text-bold">{cellProps?.rejected || "0"}</div>
                            <div className="subheader-2 font-size-12">Rejected</div>
                        </Grid>
                    </Grid>
                )
            },
        }
        if (!props?.isDirectSeller) {
            const tempHeader = [...header];
            tempHeader.splice(2, 0, data);
            return tempHeader;
        }
        return header;
    }

    const header = [
        {
            Header: "Listing",
            columnID: "title",
            minWidth: 250,
            accessor: (cellProps) => {
                const statusObj = vehicleStatusList.find(item => item.value === cellProps?.bike_advert_type);
                return (
                    <div className="d-flex align-items-center">
                        <div style={{ marginRight: 10 }}>
                            <img src={cellProps?.base64 || Helpers.noImage} alt="vehicle" style={{ width: 45, objectFit: 'contain' }} />
                        </div>
                        <div >
                            <div className="text-bold">{cellProps?.info?.title || '-'}</div>
                            <div className="subheader-2 font-size-12 align-items-center d-flex">
                                <span style={{ color: statusObj?.color }}>{statusObj?.label || "-"}</span>
                                {cellProps?.info?.register_number && <>
                                    <span style={{ color: '#A0A0A0', fontSize: '18px', margin: '0 8px' }}>&bull;</span>
                                    <span>{cellProps?.info?.register_number || "-"}</span>
                                </>}
                            </div>
                        </div>
                    </div>
                )
            },
        },
        {
            Header: "Price",
            columnID: "price",
            accessor: (cellProps) => {
                return (
                    <>
                        {
                            cellProps?.bike_advert_type === 'rental' ?
                                <>
                                    <div className="text-bold">${cellProps?.rental_rate?.daily_rate || "0.00"}</div>
                                    <div className="subheader-2 font-size-12">{"Daily rate"}</div>
                                </> :
                                <>
                                    {/* <div className="text-bold">${(cellProps?.pricing?.pricing_type === 4 ? cellProps?.pricing?.selling_price : cellProps?.pricing?.machine_price) || "0.00"}</div> */}
                                    <div className="text-bold">{(cellProps?.price) || "0.00"}</div>
                                    <div className="subheader-2 font-size-12">{cellProps?.pricing?.pricing_type_name || "-"}</div>
                                </>
                        }
                    </>
                )
            },
        },
        {

            Header: "Expires On",
            columnID: "expired_date",
            accessor: (cellProps) => {
                return (
                    <>
                        {cellProps?.expired_date || "-"}
                        {
                            cellProps?.is_near_expiry === 1 &&
                            <Icon
                                icon={'solar:danger-triangle-bold'}
                                style={{ color: '#FFCD71', marginLeft: '5px', width: 16, height: 16 }}
                            />
                        }
                    </>
                )
            },
        },
        {
            Header: "Status",
            columnID: "status",
            accessor: (cellProps) => {
                return (cellProps?.status ? <Label.GeneralStatusLabel label={cellProps.status} list={Helpers.advertStatus} /> : "-")
            },
        },
        {
            Header: "Featured",
            accessor: (cellProps) => {
                return (
                    <div onClick={(e) => e.stopPropagation()}><Toggle checked={cellProps?.is_featured || false} onChange={(e) => { e.stopPropagation(); handleFeaturedChangeValue(cellProps) }} /></div>
                )
            },
        },
    ]
    // for paused 
    // { iconName: 'solar:pause-linear', label: 'Set as Paused', color: '#1D1B1B', permission: editable, onClick: () => { handleActionClick('pause') } },

    const draftDropdownList = [
        { iconName: 'solar:upload-minimalistic-linear', label: 'Publish Selected', color: '#1D1B1B', permission: editable, onClick: () => { handleActionClick('publish') } },
        { iconName: 'solar:trash-bin-2-linear', label: 'Delete Selected', color: '#D13536', permission: deletable, onClick: () => { handleActionClick('delete') } },
    ]

    const pendingApprovalDropdownList = [
        // { iconName: 'solar:archive-down-minimlistic-linear', label: 'Move to Draft', color: '#1D1B1B', permission: editable, onClick: () => { handleActionClick('move_to_draft') } },
        { iconName: 'solar:trash-bin-2-linear', label: 'Delete Selected', color: '#D13536', permission: deletable, onClick: () => { handleActionClick('delete') } },
    ]

    const publishedDropdownList = [
        { iconName: 'fluent:door-tag-20-regular', label: 'Mark as Reserved', permission: editable, onClick: () => { handleActionClick('reserve') } },
        { iconName: 'solar:check-read-linear', label: 'Mark as Sold', color: '#1D1B1B', permission: editable, onClick: () => { handleActionClick('mark_as_sold') } },
        { iconName: 'solar:refresh-linear', label: 'Renew Selected', color: '#1D1B1B', permission: editable, onClick: () => { handleActionClick('renew') } },
        { iconName: 'formkit:hidden', label: 'Set as Hidden', color: '#1D1B1B', permission: editable, onClick: () => { handleActionClick('hidden') } },
        { iconName: 'solar:trash-bin-2-linear', label: 'Delete Selected', color: '#D13536', permission: deletable, onClick: () => { handleActionClick('delete') } },
    ]

    const reservedDropdownList = [
        { iconName: 'solar:undo-left-round-linear', label: 'Revert to Published', permission: deletable, onClick: () => { setRevertStatus('published'); handleActionClick('revert_status') } },
        { iconName: 'solar:check-read-linear', label: 'Mark as Sold', color: '#1D1B1B', permission: editable, onClick: () => { handleActionClick('mark_as_sold') } },
        { iconName: 'formkit:hidden', label: 'Set as Hidden', color: '#1D1B1B', permission: editable, onClick: () => { handleActionClick('hidden') } },

        { iconName: 'solar:trash-bin-2-linear', label: 'Delete Selected', color: '#D13536', permission: deletable, onClick: () => { handleActionClick('delete') } },
    ]

    const soldDropdownList = [
        { iconName: 'solar:undo-left-round-linear', label: 'Revert to Published', permission: deletable, onClick: () => { setRevertStatus('published'); handleActionClick('revert_status') } },
        { iconName: 'fluent:door-tag-20-regular', label: 'Mark as Reserved', permission: editable, onClick: () => { handleActionClick('reserve') } },
        { iconName: 'formkit:hidden', label: 'Set as Hidden', color: '#1D1B1B', permission: editable, onClick: () => { handleActionClick('hidden') } },
        { iconName: 'solar:trash-bin-2-linear', label: 'Delete Selected', color: '#D13536', permission: deletable, onClick: () => { handleActionClick('delete') } },
    ]

    const expiredDropdownList = [
        { iconName: 'solar:refresh-linear', label: 'Renew Selected', color: '#1D1B1B', permission: editable, onClick: () => { handleActionClick('renew') } },
        { iconName: 'formkit:hidden', label: 'Set as Hidden', color: '#1D1B1B', permission: editable, onClick: () => { handleActionClick('hidden') } },

        { iconName: 'solar:trash-bin-2-linear', label: 'Delete Selected', color: '#D13536', permission: deletable, onClick: () => { handleActionClick('delete') } },
    ]

    const hiddenDropdownList = [
        { iconName: 'solar:undo-left-round-linear', label: 'Revert to Published', permission: deletable, onClick: () => { setRevertStatus('published'); handleActionClick('revert_status') } },
        { iconName: 'fluent:door-tag-20-regular', label: 'Mark as Reserved', permission: editable, onClick: () => { handleActionClick('reserve') } },
        { iconName: 'solar:check-read-linear', label: 'Mark as Sold', color: '#1D1B1B', permission: editable, onClick: () => { handleActionClick('mark_as_sold') } },
        { iconName: 'solar:trash-bin-2-linear', label: 'Delete Selected', color: '#D13536', permission: deletable, onClick: () => { handleActionClick('delete') } },
    ]
    const dashboardCountData = props?.dashboardInfo?.data?.bike_advert_counts || {};

    const tabList = [
        { value: 'draft', label: `Draft (${dashboardCountData?.draft || 0})` },
        { value: 'pending_approval', label: `Pending Approval (${dashboardCountData?.pending_approval || 0})` },
        { value: 'published', label: `Published (${dashboardCountData?.published || 0})` },
        { value: 'reserved', label: `Reserved (${dashboardCountData?.reserved || 0})` },
        { value: 'sold', label: `Sold (${dashboardCountData?.sold || 0})` },
        { value: 'expired', label: `Expired (${dashboardCountData?.expired || 0})` },
        { value: 'hidden', label: `Hidden (${dashboardCountData?.hidden || 0})` },
        { value: 'all', label: `All (${dashboardCountData?.all || 0})` },
    ];

    const initData = () => {
        setIsLoading(true);
        dispatch(getDashboardInfo({
            page, sort, sort_by,
            size: length, dealer_id: currentDealer, tab: tabValue,
            search: searchRef.current || '',
            bike_advert_type: filterObject?.advert_type?.length > 0 ? filterObject?.advert_type?.filter((x) => x !== 'all') : [],
            bike_make_ids: filterObject?.make || [],
            bike_model_ids: filterObject?.model || [], bike_types: filterObject?.bike_types || [],
            // vehicle_source: filterObject?.license_category || [],
            price_range_from: filterObject?.min_price || "",
            price_range_to: filterObject?.max_price || "",
            created_at_from: filterObject?.from ? moment(filterObject?.from, "DD/MM/YYYY")?.format?.("YYYY/MM/DD") : "",
            created_at_to: filterObject?.to ? moment(filterObject?.to, "DD/MM/YYYY")?.format?.("YYYY/MM/DD") : "",
            license_category_ids: filterObject?.license_category || [],

        }));
    }

    const handleActionClick = (action) => {
        if (selectedIds?.length === 0 || !selectedIds) {
            setNotification({ open: true, type: 'error', msg: 'Please select at least one advert to perform this action.' });
            return;
        }
        switch (action) {
            case 'mark_as_sold':
                setSoldOpen(true);
                break;
            case 'renew':
                setRenewOpen(true);
                break;
            case 'publish':
                setPublishOpen(true);
                break;
            case 'move_to_draft':
                setMoveDraftOpen(true);
                break;
            case 'reserve':
                setReservedOpen(true);
                break;
            case 'revert_status':
                setRevertStatusOpen(true);
                break;
            case 'hidden':
                setMoveToHiddenOpen(true);
                break;
            case 'delete':
                setDeleteOpen(true);
                break;

        }
    }

    const handleCheckboxChange = (e, item) => {
        let temp = [];
        let tempItem = [];
        if (selectedIds && selectedIds?.includes(parseInt(e))) {
            temp = selectedIds.filter((x) => x !== parseInt(e)).map((y) => y);
            tempItem = selectedRow.filter((x) => x.id !== parseInt(e)).map((y) => y);
            setSelectedRow(tempItem)
            setSelectedIds(temp)
        } else {
            setSelectedIds([...selectedIds, parseInt(e)])
            setSelectedRow([...selectedRow, item])
        }
    }

    const handleFeaturedChangeValue = (rowData) => {
        setIsLoading(true);
        dispatch(updateAdvert({
            id: rowData?.id,
            data: { action: "toggle_feature", is_featured: rowData?.is_featured === 1 ? 0 : 1 }
        }));
    }

    const handleDelete = () => {
        if (selectedIds?.length === 0 || !selectedIds) {
            setNotification({ open: true, type: 'error', msg: 'Please select at least one advert to delete.' });
            return;
        }
        setIsLoading(true);
        dispatch(deleteAdvert({ ids: selectedIds }));
    }

    const handleMarkAsSold = () => {
        if (selectedIds?.length === 0 || !selectedIds) {
            setNotification({ open: true, type: 'error', msg: 'Please select at least one advert to delete.' });
            return;
        }
        setIsLoading(true);
        let payload = {
            action: 'update_status',
            ids: selectedIds,
            status: 'sold'
        }
        dispatch(bulkUpdateAdvert(payload))
    }

    const handleMoveToHidden = () => {
        if (selectedIds?.length === 0 || !selectedIds) {
            setNotification({ open: true, type: 'error', msg: 'Please select at least one advert to delete.' });
            return;
        }
        setIsLoading(true);
        let payload = {
            action: 'update_status',
            ids: selectedIds,
            status: 'hidden'
        }
        dispatch(bulkUpdateAdvert(payload))
    }

    const handleRenewAdvert = () => {
        if (selectedIds?.length === 0 || !selectedIds) {
            setNotification({ open: true, type: 'error', msg: 'Please select at least one advert to delete.' });
            return;
        }
        setIsLoading(true);
        let payload = {
            action: 'renew_plan',
            ids: selectedIds,
        }
        dispatch(bulkUpdateAdvert(payload))
    }

    const handlePublish = () => {
        if (selectedIds?.length === 0 || !selectedIds) {
            setNotification({ open: true, type: 'error', msg: 'Please select at least one advert to delete.' });
            return;
        }
        setIsLoading(true);
        let payload = {
            action: 'update_status',
            ids: selectedIds,
            status: 'published'
        }
        dispatch(bulkUpdateAdvert(payload))
    }

    const handleMoveToDraft = () => {
        if (selectedIds?.length === 0 || !selectedIds) {
            setNotification({ open: true, type: 'error', msg: 'Please select at least one advert to delete.' });
            return;
        }
        setIsLoading(true);
        let payload = {
            action: 'update_status',
            ids: selectedIds,
            status: 'draft'
        }
        dispatch(bulkUpdateAdvert(payload))
    }

    const handleMarkAsReserved = () => {
        if (selectedIds?.length === 0 || !selectedIds) {
            setNotification({ open: true, type: 'error', msg: 'Please select at least one advert to delete.' });
            return;
        }
        setIsLoading(true);
        let payload = {
            action: 'update_status',
            ids: selectedIds,
            status: 'reserved'
        }
        dispatch(bulkUpdateAdvert(payload))
    }

    const handleRevertStatus = () => {
        if (selectedIds?.length === 0 || !selectedIds) {
            setNotification({ open: true, type: 'error', msg: 'Please select at least one advert to revert.' });
            return;
        }
        setIsLoading(true);
        let payload = {
            action: 'update_status',
            ids: selectedIds,
            status: revertStatus
        }
        dispatch(bulkUpdateAdvert(payload))
    }

    const getLengthPage = (page, length) => {
        setPage(page)
        setLength(length)
    }

    const resetFilter = () => {
        setFilterObject({ status: "all", advert_type: ['all'], make: [], model: [], bike_type: [], licenseCategory: [] });
        setStartDate("");
        setEndDate("");
        setSearch(""); // Clear search keyword
        searchRef.current = ""; // Update searchRef
        setPage(page === 1 ? '1' : 1);
    }

    const applyFilter = (sort, sortBy) => {
        setSortBy(sortBy || 'id');
        setSorted(sort || 'desc');
        setPage(page === 1 ? '1' : 1);
        setDrawerOpen(false);
    }

    const filterList = [
        {
            label: "Advert Type",
            type: "checkbox",
            value: filterObject?.advert_type || [],
            data: Helpers.advertTypeList,
            xsGrid: 12,
            mdGrid: 12,
            onChange: (e, item) => {
                setFilterObject((prevValues) => ({
                    ...prevValues,
                    advert_type: e,
                }))
            }
        },
        {
            label: "Make",
            type: "checkbox",
            value: filterObject?.make || [],
            data: props?.makeList || [],
            xsGrid: 12,
            mdGrid: 12,
            onChange: (e, item) => {
                setFilterObject((prevValues) => ({
                    ...prevValues,
                    make: e,
                }))
            }
        },
        {
            label: "Model",
            type: "checkbox",
            value: filterObject?.model || [],
            data: props?.modelList || [],
            xsGrid: 12,
            mdGrid: 12,
            onChange: (e, item) => {
                setFilterObject((prevValues) => ({
                    ...prevValues,
                    model: e,
                }))
            }
        },
        {
            label: "Body Type",
            type: "checkbox",
            value: filterObject?.bike_types || [],
            data: props?.bikeTypeList || [],
            xsGrid: 12,
            mdGrid: 12,
            onChange: (e, item) => {
                setFilterObject((prevValues) => ({
                    ...prevValues,
                    bike_types: e,
                }))
            }
        },
        {
            label: "Price Range",
            type: "priceRange",
            minValue: filterObject?.min_price || "",
            maxValue: filterObject?.max_price || "",
            prefix: "$",
            setMinAmount: (value) => {
                setFilterObject({ ...filterObject, min_price: value })
            },
            setMaxAmount: (value) => {
                setFilterObject({ ...filterObject, max_price: value })
            },
        },
        {
            label: "License Category",
            type: "checkbox",
            value: filterObject?.license_category || [],
            data: props?.licenseCategoryList || [],
            xsGrid: 12,
            mdGrid: 12,
            onChange: (e, item) => {
                setFilterObject((prevValues) => ({
                    ...prevValues,
                    license_category: e,
                }))
            }
        },
        {
            label: "Created Date",
            value: filterObject?.createdDate,
            type: "date_range",
            startPlaceholder: "From",
            endPlaceholder: "To",
            startDateTitle: "From",
            startDate: startDate,
            setStartDate: (date) => {
                setStartDate(date);
                const formattedDate = date ? moment(date).format('DD/MM/YYYY') : "";
                setFilterObject((prev) => ({ ...prev, from: formattedDate }));
            },
            endDateTitle: "To",
            endDate: endDate,
            setEndDate: (date) => {
                setEndDate(date);
                const formattedDate = date ? moment(date).format('DD/MM/YYYY') : "";
                setFilterObject((prev) => ({ ...prev, to: formattedDate }));
            },
            xsGrid: 12, smGrid: 12, mdGrid: 12
        },
    ]

    const handleSearch = (text) => {
        setSearch(text);
        setTimeout(() => {
            if (text === searchRef.current) {
                initData();
            }
        }, Helpers.searchInterval);
    }

    const renderUserInfo = (title, value) => {
        return (
            <Grid item md={2.4} sm={6} xs={12}>
                <div className="subheader-2">{title}</div>
                <div className="text-bold font-size-18">{value || '0'}</div>
            </Grid>
        )
    }

    const typeList = [
        { label: 'All', value: 'all' },
        { label: 'New Motorcycle', value: 'new' },
        { label: 'Used Motorcycle', value: 'used' },
        { label: 'For Rent', value: 'rental' },
    ]

    const dropdownList = tabValue === 'draft' ? draftDropdownList :
        tabValue === 'pending_approval' ? pendingApprovalDropdownList :
            tabValue === 'published' ? publishedDropdownList :
                tabValue === 'reserved' ? reservedDropdownList :
                    tabValue === 'sold' ? soldDropdownList :
                      tabValue === 'hidden' ? hiddenDropdownList :
                        expiredDropdownList;

    const customToolsBar = () => {
        return (
            <Grid container rowSpacing={2} mb={2} paddingBlock={1}>
                <Grid container item lg={9} md={12} style={{ display: 'flex', alignItems: "center" }} spacing={1}>
                    <Grid item lg={3} md={2} xs={12} className="d-flex">
                        <SearchBar
                            value={search}
                            setValue={(e) => handleSearch(e)}
                        />
                    </Grid>
                    <Grid item lg={3} md={2} xs={12} mt={1}>
                        <CustomSelect2
                            values={filterObject?.advert_type?.[0] || "-1"}
                            onChange={(e) => {
                                setFilterObject((prevValues) => ({
                                    ...prevValues,
                                    advert_type: [e]
                                }))
                                setPage((prevPage) => (prevPage === 1 ? '1' : 1));
                            }}
                            data={typeList}
                            placeholder={"All"}
                            height={35}
                            startAdornment={<div className="subheader-2" style={{ marginRight: 5 }}>Type: </div>}
                        />
                    </Grid>
                    <Grid item lg={2.1} md={2} xs={12}>
                        <PopOverFilter
                            setDialogOpen={setDrawerOpen}
                            open={drawerOpen}
                            applyFilter={applyFilter}
                            filterData={filterList}
                            setFilterObject={setFilterObject}
                            sort={sort}
                            sort_by={sort_by}
                            filterList={filterList}
                            handleResetFilter={resetFilter}
                        />
                    </Grid>
                    <Grid item lg={2} md={2} xs={12}>
                        <CustomButton
                            title={<div style={{ textDecorationLine: 'underline' }}>Clear</div>}
                            press={() => resetFilter()}
                            height={32}
                            backgroundColor={'transparent'}
                            textColor={'#B48A3C'}
                            borderStyle={'none'}
                        />
                    </Grid>
                </Grid>
                {
                    tabValue !== 'all' &&
                    <Grid item lg={3} md={12} className="d-flex align-items-center" sx={{ justifyContent: { lg: 'end', md: 'start' } }}>
                        <CustomButton
                            title={'Select'}
                            press={() => setStartSelecting(!startSelecting)}
                            height={32}
                            backgroundColor={startSelecting ? '#F5F5F5' : 'white'}
                            textColor={'#000'}
                            borderStyle={startSelecting ? "1px solid #E3E8EE" : "1px solid #babcbe"}
                            marginRight={startSelecting ? 5 : 0}
                        />
                        {
                            startSelecting &&
                            <RenderPopOverButton
                                items={dropdownList}
                                customTitle={
                                    <CustomButton
                                        title={<>Bulk Actions<Icon icon={'fluent:chevron-down-20-regular'} style={{ marginLeft: 10, color: '#525252CC' }} /></>}
                                        press={() => { }}
                                        height={32}
                                        backgroundColor={'white'}
                                        textColor={'#000'}
                                        borderStyle={"1px solid #babcbe"}
                                    />
                                }
                            />
                        }
                    </Grid>
                }
            </Grid>
        )
    }

    const mobileViewTable = () => {
        return (
            <div>
                <AppTab tabValue={tabValue} setTabValue={setTabValue} tabList={tabList} marginBottom={5} />
                <CustomTextField
                    values={search}
                    onChange={(e) => setSearch(e)}
                    placeholder={'Search by make, model, title or reg. no'}
                    InputProps={{ startAdornment: <Icon icon={'fluent:search-16-regular'} style={{ marginRight: 8, height: 20, width: 20 }} /> }}
                    backgroundColor={'#FAFAFA'}
                    borderRadius={57}
                />
                {
                    tabValue !== 'all' &&
                    <div className="d-flex align-items-center my-3" style={{ flexWrap: 'wrap' }}>
                        <CustomButton
                            title={'Select'}
                            press={() => setStartSelecting(!startSelecting)}
                            height={32}
                            backgroundColor={startSelecting ? '#F5F5F5' : 'white'}
                            textColor={'#000'}
                            borderStyle={startSelecting ? "1px solid #E3E8EE" : "1px solid #babcbe"}
                            marginRight={5}
                        />
                        {
                            startSelecting &&
                            <RenderPopOverButton
                                items={dropdownList}
                                customTitle={
                                    <CustomButton
                                        title={<>Bulk Actions<Icon icon={'fluent:chevron-down-20-regular'} style={{ marginLeft: 10, color: '#525252CC' }} /></>}
                                        press={() => { }}
                                        height={32}
                                        backgroundColor={'white'}
                                        textColor={'#000'}
                                        borderStyle={"1px solid #babcbe"}
                                        marginRight={5}
                                        width={150}
                                    />
                                }
                            />
                        }
                        <CustomButton
                            title={<>Filter<Icon icon={'fluent:filter-20-regular'} style={{ marginLeft: 5, color: '#525252CC' }} /></>}
                            press={() => { }}
                            height={32}
                            backgroundColor={'white'}
                            textColor={'#000'}
                            borderStyle={"1px solid #babcbe"}
                        // marginTop={startSelecting && 10}
                        />
                    </div>
                }

                {
                    (dashboardListData?.data || []).map((item) => {
                        return (
                            <div className="d-flex align-items-center py-3" style={{ borderBottom: '1px solid #E2E2E2' }} onClick={() => navigate(`/advert/${item?.id}`)}>
                                {
                                    startSelecting &&
                                    <div className="text-center" onClick={(e) => e.stopPropagation()}>
                                        <Checkbox
                                            checked={checkedAll ? checkedAll : selectedIds && selectedIds?.length > 0 && selectedIds?.includes(item.id)}
                                            checkedIcon={Helpers.checkIcon()}
                                            icon={<div style={{ width: 18, height: 18, borderRadius: 3, border: '2px solid #1D1B1B' }}></div>}
                                            sx={{
                                                '&.Mui-checked': {
                                                    color: "#a0a0a0",
                                                },
                                                '& .MuiSvgIcon-root': {
                                                    fontSize: 18,
                                                },
                                            }}
                                            value={item.id}
                                            onChange={(event) => { handleCheckboxChange(event.target.value, item) }} />
                                    </div>
                                }
                                <div style={{ marginRight: 10 }}>
                                    <img src={item?.base64 || Helpers.noImage} alt="vehicle" style={{ width: 45, objectFit: 'contain' }} />
                                </div>
                                <div >
                                    <div className="text-bold">{item?.info?.title || "-"}</div>
                                    <div className="align-items-center d-flex">
                                        <Label.GeneralStatusLabel label={item.status} list={Helpers.advertStatus} marginLeft={"0px"} />
                                        <div className="mx-2 text-semibold">${item?.pricing?.price || item?.rental_rate?.daily_rate || "-"}</div>
                                    </div>
                                </div>
                            </div>
                        )
                    })
                }

            </div>
        )
    }

    const dashboardListData = props?.dashboardInfo?.data?.bike_adverts || null;
    const dashboardDealerData = props?.dashboardInfo?.data?.counts || null;
    const currentDealerName = props?.dashboardOptions?.data?.find((item) => item.dealer_id === currentDealer)?.dealer_name || "-"
    const currentAccount = props?.currentUser?.selected_dealer_id ? props?.currentUser?.active_dealer_users?.find(user => user.dealer_id === props?.currentUser?.selected_dealer_id) : props?.currentUser;
    const filterTabList = !props?.isDirectSeller ? tabList.filter(item => item.value !== 'pending_approval') : tabList; // if direct seller then show pending approval tab otherwise hide it

    return (
        <React.Fragment>
            <div className="page-content" style={{ marginTop: width <= 768 && props.leftSideBarType === 'condensed' ? 72 : 0 }}>
                <LoadingDialog open={loading || !props?.dashboardInfo?.data} />
                <Notification notification={notification} setNotification={setNotification} />
                <Container fluid style={{}}>
                    <Stack className="text-bold font-size-18 d-flex" sx={{ flexDirection: { lg: 'row', md: 'row', sm: 'block' }, gap: 2, justifyContent: { lg: 'space-between', md: 'space-between' }, alignItems: { lg: 'center', md: 'center' } }}>
                        Welcome back, {props?.currentUser?.name ? props?.currentUser?.name : "User"}
                        {currentAccount?.dealer_id && currentAccount?.has_dashboard_access ? <div style={{ maxWidth: 250 }}>
                            <CustomSelect2
                                values={currentDealer || "-1"}
                                onChange={(e) => {
                                    setCurrentCompany(e);
                                }}
                                data={props.dashboardOptions?.data || []}
                                valueName={'dealer_id'}
                                labelName={'dealer_name'}
                                placeholder={'Select'}
                            />
                        </div> : ""}
                    </Stack>
                    <div className="mt-3 dashboard-card">
                        <Grid container spacing={2}>
                            <Grid item sm={12} className="d-flex align-items-center text-bold font-size-18">
                                {currentAccount?.dealer_id ? currentDealerName : ""}
                                {currentDealerName && currentAccount?.dealer_id ? <Label.GeneralStatusLabel list={Helpers.userType} label={'dealer'} borderRadius={'30px'} /> : ""}
                            </Grid>
                            {renderUserInfo('Total Active Listings', dashboardDealerData?.total_active_adverts || 0)}
                            {renderUserInfo('Total Inquiries', dashboardDealerData?.total_inquiries || 0)}
                            {!(props?.isDirectSeller && !currentDealer) && renderUserInfo('Loan Applications', dashboardDealerData?.total_loans || 0)}
                            {renderUserInfo('Boosted Ads', dashboardDealerData?.total_boosted_adverts || 0)}
                            {renderUserInfo('Credit Balance', dashboardDealerData?.total_credit_balance || 0)}
                        </Grid>
                    </div>
                    {/* {planInfo()} */}
                    {
                        width > 768 ?
                            <>
                                <AppTab tabValue={tabValue} setTabValue={setTabValue} tabList={filterTabList} marginBottom={5} />
                                {customToolsBar()}
                                <Table
                                    header={startSelecting ? [...deleteCheckBox, ...getHeader()] : getHeader()}
                                    data={dashboardListData?.data || []}
                                    pageSize={length}
                                    totalPage={dashboardListData?.last_page || 1}
                                    getLengthPage={getLengthPage}
                                    customToolsBar={true}
                                    setCheckedAll={setCheckedAll}
                                    setSorted={setSorted}
                                    sort_by={sort_by}
                                    setSortBy={setSortBy}
                                    checkedAll={checkedAll}
                                    sort={sort}
                                    onTableRowClick={(row) => { navigate(`/advert/${row.id}`) }}
                                />

                            </>
                            : mobileViewTable()
                    }
                    <TablePageControl
                        from={dashboardListData?.from || 0}
                        to={dashboardListData?.to || 0}
                        total={dashboardListData?.total || 0}
                        length={length}
                        setLength={setLength}
                        page={page}
                        setPage={setPage}
                        totalPage={dashboardListData?.last_page || 1}
                    />
                </Container>
                <MarkSold
                    open={soldOpen}
                    close={() => setSoldOpen(false)}
                    handleSubmit={() => { handleMarkAsSold() }}
                    windowWidth={width}
                    isBulkAction={true}
                    selectedItems={selectedRow}
                />
                <MoveToHidden
                    open={moveToHiddenOpen}
                    close={() => setMoveToHiddenOpen(false)}
                    handleSubmit={() => { handleMoveToHidden() }}
                    isBulkAction={true}
                    selectedItems={selectedRow}
                    windowWidth={width}
                />
                <PublishAdvert
                    open={publishOpen}
                    close={() => setPublishOpen(false)}
                    handleSubmit={() => { handlePublish() }}
                    windowWidth={width}
                    isBulkAction={true}
                    selectedItems={selectedRow}
                />
                <RenewAdvert
                    open={renewOpen}
                    close={() => setRenewOpen(false)}
                    handleSubmit={() => { handleRenewAdvert() }}
                    advertData={{ remaining_boosts: 2 }}
                    isBulkAction={true}
                    selectedItems={selectedRow}
                    windowWidth={width}
                />
                <MoveDraft
                    open={moveDraftOpen}
                    close={() => setMoveDraftOpen(false)}
                    handleSubmit={() => { handleMoveToDraft() }}
                    isBulkAction={true}
                    selectedItems={selectedRow}
                    windowWidth={width}
                />
                <MarkReserved
                    open={reservedOpen}
                    close={() => setReservedOpen(false)}
                    handleSubmit={() => { handleMarkAsReserved() }}
                    isBulkAction={true}
                    selectedItems={selectedRow}
                    windowWidth={width}
                />
                <RevertStatus
                    open={revertStatusOpen}
                    close={() => setRevertStatusOpen(false)}
                    handleSubmit={() => { handleRevertStatus() }}
                    isBulkAction={true}
                    selectedItems={selectedRow}
                    windowWidth={width}
                    revertStatus={revertStatus}
                />
                <AppDialog
                    open={deleteOpen}
                    close={() => setDeleteOpen(false)}
                    title={`Delete Selected Advert`}
                    positiveTitle={'Delete'}
                    positiveButtonStyle={{ backgroundColor: '#D13536', color: 'white', borderRadius: 20, width: 'auto', border: '1px solid #D13536' }}
                    positivePress={() => handleDelete()}
                    cancelButton={true}
                    width={'40%'}
                    windowWidth={width}
                >
                    <div>Are you sure you want to delete {selectedRow.length} selected advert(s)?</div>
                    <ol style={{ paddingInline: 20, paddingBlock: 10 }}>
                        {itemsToShow?.map((item, idx) => (
                            <li key={idx} className="mb-2 ">
                                <div className="d-flex align-items-center">
                                    {item?.make?.name || '-'} {item?.model?.model_name || ''}
                                    <Label.GeneralStatusLabel label={item?.status || '-'} list={Helpers.advertStatus} marginLeft={"10px"} />
                                </div>
                            </li>
                        ))}
                        {selectedRow.length > 2 && (
                            <div
                                onClick={() => setShowAll(!showAll)}
                                className="clickable underline"
                                style={{ marginTop: '10px' }}
                            >
                                {showAll ? 'Show less' : 'Show more'}
                            </div>
                        )}
                    </ol>
                    <div className="my-2">Once deleted:</div>
                    <ul className="subheader-2" style={{ padding: 5, paddingInline: 15 }}>
                        <li className="mb-2">The adverts will be permanently removed from the marketplace.</li>
                        <li className="mb-2">Enquiries and performance data for the selected adverts will be lost.</li>
                    </ul>
                </AppDialog>
            </div >
            {/* <Footer></Footer> */}
        </React.Fragment >
    );

}

const mapStatetoProps = state => {
    const { loginError } = state.Login;
    return {
        loginError,
        dashboardInfo: state.Dashboard.dashboardInfo,
        dashboardOptions: state.Dashboard.dashboardOptions,
        userPermission: state.Login.permissionArry,
        leftSideBarType: state.Layout.leftSideBarType,
        currentUser: state.Login.verifyAdmin?.user?.data?.profile,
        editAdvert: state.Advert?.advertBulkEdit,
        editAdvertFeatured: state.Advert?.advertEdit,
        advertDelete: state.Advert?.advertDelete,
        isDirectSeller: state.Login.verifyAdmin?.user?.data?.profile?.selected_dealer_id ? false : true,
        makeList: state.General.bike_makes?.map((x, idx) => ({
            label: x.name,
            value: x.id
        })) || [],
        modelList: state.General.bike_models?.map((x, idx) => ({
            label: x.name,
            value: x.id
        })) || [],
        bikeTypeList: state.General.bike_types?.map((x, idx) => ({
            label: x.name,
            value: x.id
        })) || [],
        licenseCategoryList: state.General.license_categories?.map((x, idx) => ({
            label: x.name,
            value: x.id
        })) || [],

    };
}

// export default withRouter(connect(null, { verify_admin, getDashboardInfo })(Dashboard));
export default connect(mapStatetoProps)(Dashboard);
